import { FocusTrapper } from "./FocusTrapper";
import { IFocusTrapper } from "./interfaces/IFocusTrapper";

export const focusTrapper: IFocusTrapper = new FocusTrapper();
